module.exports = __webpack_public_path__ + "static/cardstructure-fixed-146a781cd29f596ce1d1070580f0bced.png";